import * as React from "react"
import { useTranslation } from "react-i18next"
import Element from "@bappweb/element"
import Page from "@components/globalmodules/page"

const ExchangeRates = () => {
  const { t } = useTranslation()

  return (
    <Page>
      <Element type="h1">{t("Exchange Rates")}</Element>
    </Page>
  )
}

export default ExchangeRates
